/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

window.openMenu = null;
var $ = jQuery;


/**
 * Calculates the position of a given element within the viewport
 *
 * @param {string} obj jQuery object of the dom element to be monitored
 * @return {array} An array containing both X and Y positions as a number
 * ranging from 0 (under/right of viewport) to 1 (above/left of viewport)
 */
function visibility(obj) {
  var winw = jQuery(window).width(), winh = jQuery(window).height(),
    elw = obj.width(), elh = obj.height(),
    o = obj[0].getBoundingClientRect(),
    x1 = o.left - winw, x2 = o.left + elw,
    y1 = o.top - winh, y2 = o.top + elh;

  return [
    Math.max(0, Math.min((0 - x1) / (x2 - x1), 1)),
    Math.max(0, Math.min((0 - y1) / (y2 - y1), 1))
  ];
}

function parallaxScroll() {
  var scrolledY = $(window).scrollTop();

  $('.wrap', '#intro')
    .css('position', 'relative')
    .css('top', '+' + (scrolledY / 2) + 'px');
}

function scrollToTop() {
  if ($(window).scrollTop() >= 50) {        // If page is scrolled more than 50px
    $('#return-to-top').fadeIn(200);    // Fade in the arrow
  } else {
    $('#return-to-top').fadeOut(200);   // Else fade out the arrow
  }
}

function map(x, in_min, in_max, out_min, out_max) {
  return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}

function resizeHeader() {
  var t = $(this).scrollTop();
  if (t > 250) {
    t = 250;
  }

  var elHeight = map(t, 0, 250, 120, 74);
  $('#top .wrap').css('height', elHeight + 'px');
  $('div.menu>div', '#top').css('top', elHeight + 'px');
}

function parallax() {
  $('.parallax').each(function () {
    var height = jQuery(this).height(),
      parent = jQuery(this).parent(),
      pos = visibility(parent)[1],
      margin = parent.height() / 2,
      from = margin,
      to = 0 - height + margin,
      marginTop = map(pos, 1, 0, from, to);

    $(this).css('margin-top', marginTop + 'px');
  });
}

jQuery(function ($) {
  $('div.overlay', '#pano').on('click', function () {
    $(this).fadeOut();
    $('.close-bar', '#pano').fadeIn();
  });

  $('#pano').on('mouseleave', function () {
    $('.overlay', '#pano').fadeIn();
    $('.close-bar', '#pano').fadeOut();
  });

  $('div.close-bar', '#pano').on('click', function () {
    $('.overlay', '#pano').fadeIn();
    $('.close-bar', '#pano').fadeOut();
  });

  // allow clicking on images as a shortcut to clicking read more link
  $('div.left>img').each(function () {
    var moreLink = $(this).closest('li').find('a.more').filter(':visible');
    if (moreLink.length) {
      $(this).css('cursor', 'pointer').on('click', function () {
        moreLink[0].click();
      });
    }
  });


  $(window).bind('scroll', function (e) {
    parallaxScroll();
    scrollToTop();
  });

  $(function () {
    resizeHeader();
  });

  $(window).load(function () {
    resizeHeader();
    parallaxScroll();
  });

  //jQuery(window).on('scroll', _.throttle(resizeHeader, 50));


  (function () {
    window.onscroll = function () {
      parallax();
    };
  })();

  // run automatic (ugly fix because onscroll was not always working)
  if ($('.parallax').length) {
    //setInterval(parallax, 10);
  }

  $('div.menu1 div.inner').html($('li#menu-item-79 .sub-menu').html());
  $('div.menu2 div.inner').html($('li#menu-item-83 .sub-menu').html());

  // header menu
  $('ul#menu-top>li')
    .hover(function () {
      window.openMenu = null;
      $('div.menu>div').hide();
      if ($(this).attr('id') === 'menu-item-79') {
        $('div.menu1').show();
        setTimeout(function () {
          window.openMenu = 1;
        }, 10);
      }
      if ($(this).attr('id') === 'menu-item-83') {
        $('div.menu2').show();
        setTimeout(function () {
          window.openMenu = 2;
        }, 10);
      }
    });

  $('#top').on('mouseleave', function () {
    $('div.menu>div').hide();
    window.openMenu = null;
  });

  jQuery('#menu-item-79').on('click', function () {
    if (window.openMenu === 1) {
      jQuery('div.menu1').hide();
      window.openMenu = null;
    } else {
      jQuery('div.menu1').show();
      window.openMenu = 1;
    }
    return false;
  });

  jQuery('#menu-item-83').on('click', function () {
    if (window.openMenu === 2) {
      jQuery('div.menu2').hide();
      window.openMenu = null;
    } else {
      jQuery('div.menu2').show();
      window.openMenu = 2;
    }
    return false;
  });

  $('.frm_form_fields .form-field:not(.ignore)').each(function () {
    var $label = $('label', $(this));

    if ($(this).hasClass('frm_required_field')) {
      if ($label.text().indexOf('*') === -1) {
        $label.text($label.text() + ' *');
      }
    }

    var label = $label.text()
      .replace(/\r?\n|\r/, " ")
      .replace(/\s+/g, " ");

    if ($('input,textarea', $(this)).length) {
      $('input,textarea', $(this)).attr('placeholder', label);
      $label.remove();
    }
    if ($('select', $(this)).length) {
      $('<option/>').text(label)
        .attr('selected', 'selected')
        .prependTo($('select', $(this)));
      $label.remove();
    }
  });


  $(function () {
    var anchor = window.location.hash.substr(1);
    if (anchor.substr(0, 5) === 'item-') {
      jQuery('#' + anchor).parent()
        .children('div.collapsable')
        .addClass('expanded');
    }
  });

  $(document).ready(function () {
    jQuery('ul.slider', '#photo-slider').bxSlider({
      minSlides: 3,
      maxSlides: 10,
      speed: 500,
      slideHeight: 380,
      slideWidth: 380,
      moveSlides: 1,
      slideMargin: 0
    });

    jQuery('ul.slider', '#testimonials').bxSlider({
      maxSlides: 1
    });
  });

  // faq
  $(document).ready(function () {
    jQuery('div.toggle').on('click', function () {

      $('li.faq-item.open').each(function () {
        $(this).children('.post-content').slideUp(200);
        $(this).removeClass('open');
      });

      var $parent = jQuery(this).parent('li');
      var $item = $parent.children('.post-content');
      if ($item.is(':hidden')) {
        $item.slideDown(200);
        $parent.addClass('open');
      } else {
        $item.slideUp(200);
        $parent.removeClass('open');
      }

      return false;
    });
  });


  // news
  $(document).ready(function () {
    jQuery('a.more,a.less', 'div.collapsable').on('click', function () {
      var $parent = jQuery(this).parents().closest('div.right');
      var $item = $parent.children('.post-content');

      if ($(this).hasClass('link')) {
        return true;
      }

      if ($parent.hasClass('expanded')) {
        $parent.removeClass('expanded');

      } else {
        $parent.addClass('expanded');
      }

      return false;
    });
  });

  //pagination fix
  jQuery('a.page-numbers').each(function () {
    var nr = jQuery(this).html();
    if (!isNaN(nr)) {
      jQuery(this).attr('href', '/lesrooster/' + nr);
    }
  });

  // redirect to anchor if ?pid=xx is in url
  function getparam(param) {
    var regex = new RegExp("(?:[?&]+" + param + "=)([^&]*)?", "i");
    var match = regex.exec(window.location.href);
    return match === null ? match : match[1];
  }

  var pid = getparam('pid');
  if (pid && pid.length > 0) {
    window.location.hash = 'item-' + pid;
  }
});

function scrollToAnchor(aid) {
  var aTag = jQuery("#" + aid);
  jQuery('html,body').animate({scrollTop: aTag.offset().top}, 'medium');
}

jQuery(function ($) {
  // subscriptions blocks
  $('#subscriptions a.block').on('click', function () {
    scrollToAnchor('frm_form_11_container');
    $('#field_gnbiw option').eq($(this).attr('href')).prop('selected', true);
    return false;
  });
});
